import { render, staticRenderFns } from "./ProposalGrid.vue?vue&type=template&id=54018536"
import script from "./ProposalGrid.vue?vue&type=script&lang=js"
export * from "./ProposalGrid.vue?vue&type=script&lang=js"
import style0 from "./ProposalGrid.vue?vue&type=style&index=0&id=54018536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports